import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MiniHed from '../SubHead/MiniHed';
import BodyText from '../BodyText/BodyText';
import Button from '../../../common/Button';
import { getFileName, isValid, isText } from '../../../../utils';

const RelatedArticle = ({
  article={},
  index,
  isMobile,
  className,
  slug,
  isPage=false,
}) => {
  const {
    articleId=null,
    articleText=null,
    articleUrl=null,
    buttonTextOverride=null,
    bodyText=null,
    category=null,
    author={},
    sponsored={},
    categoryImage={},
    creditOverride=null,
    creditUrl=null,
  } = article;

  const imageSrc = (isValid(categoryImage.multiRowDesktop)) ? categoryImage.multiRowDesktop : (isValid(categoryImage.bigcard)) ? categoryImage.bigcard : null;
  const imageAlt = (isValid(categoryImage.imageAlt)) ? categoryImage.imageAlt : getFileName(imageSrc);
  const linkUrl = `/${articleUrl}`;
  const isSponsored = (isValid(sponsored)) && ((sponsored === 'Sponsored') || (sponsored === true));
  // To remove empty space and p tags from bodyText (where no text entered in Editor in Body Text field, it's coming through as " <p></p> " in the REST)

  const removeTags = (str) => {
    if (!isValid(str)) {
      return '';
    }

    try {
      // convert '&lt;' and '&gt;' to p tags
      const regexed = str.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
      // trim whitespace and remove p tags from the str
      const transformed = regexed.replace(/<[^\/>]*>([\s]?)*<\/[^>]*>/, '').trim();
      return transformed;
    } catch(e) {
      console.log(e);
      return '';
    }
    
  };
  const transformedBodyText = isText(bodyText) ? removeTags(bodyText) : null;
  const isEmpty = (transformedBodyText === null || transformedBodyText === '');

  const buttonText = (isText(buttonTextOverride)) ? buttonTextOverride : 'Read More';
  const buttonUrl = linkUrl;
  const button = (isText(buttonText) && isText(buttonUrl)) ? { text: buttonText, url: buttonUrl } : null;
  const renderedButton = (button !== null) ? <Button button={button} /> : null;

  const renderedImage = (isValid(imageSrc)) ? <img className={className} src={imageSrc} alt={isText(imageAlt) ? imageAlt : getFileName(imageSrc)} loading="lazy"/> : null;
  let credit = (isText(creditOverride)) ?  creditOverride : (isText(categoryImage.imageCredit)) ? categoryImage.imageCredit : (isText(categoryImage.universalCredit)) ? categoryImage.universalCredit : null;
  credit = (credit && credit.toLowerCase() === "no credit") ? "" : credit;
  const renderImageCredit = () => {
    if (isValid(credit)) {
      let imgCredit = <span className="img-credit" dangerouslySetInnerHTML={ { __html: credit } }></span>;
      if (isText(creditUrl)) {
        imgCredit = <a href={creditUrl} className="img-credit" target="_blank" rel="noopener nofollow" data-link-type="credit-link" dangerouslySetInnerHTML={ { __html: credit } }></a>;
      }
      return (<div className="img-credit-container ">{imgCredit}</div>);
    } else {
      return null;
    }
  };
  const renderedImageCredit = renderImageCredit();

  // if isMobile and index === 0, margin-top: 0
  const isFirstRow = (isMobile && index === 0);
  const containerClassName = isFirstRow ? 'related-story-container below first-row' : 'related-story-container below';

  return (
    <div className={containerClassName}>
      <div className='image-wrapper'>
        {/* render image (linked or not) and sponsored text */}
        {imageSrc ? (
          <a className="large-image-link" href={linkUrl} target="_blank" rel="noopener nofollow" data-link-type="image-link" >
            <div className={`img-container-${className}`}>
              <a href={linkUrl} target="_blank" rel="noopener nofollow" data-link-type="image-link" >
                {renderedImage}
              </a>
            </div>
          </a>
        ) : (
          <div className={`img-container-${className}`}>
            <a href={linkUrl} target="_blank" rel="noopener nofollow" data-link-type="image-link">
              {renderedImage}
            </a>
          </div>
        )}
        {renderedImageCredit}
      </div>
      <div className="image-text-wrapper">
        {/* category/ author/ sponsored / isPage */}
        {(isPage && isText(articleText) && isText(author)) && 
        <Fragment>
          <div className={`category-text ${(author.length > 16 && !isMobile)  ? 'wrap' : ''}`}>
          { category &&
            <Fragment>
              <div className="card-author-category">{category}</div>
              {!isMobile && <div className="card-author-dot"></div>}
            </Fragment>
          }
          {author && !isSponsored && <div className="card-author-name">by {author}</div>}
          {isSponsored && <div className="card-author-sponsored">sponsored</div>}
        </div>
        <div className="divider"></div>
        </Fragment>
        }
        {(!isSponsored && isText(articleText) && isText(author)) && !isPage && 
          <h3 className="category-text">{category} • by {author}</h3>
        }
        {(!isSponsored && isText(articleText) && !isText(author)) && !isPage &&
          <h3 className="category-text">{category}</h3>
        }
        {(isSponsored && isText(articleText)) && !isPage &&
          <h3 className="category-text">{category} • SPONSORED</h3>
        }
        {/* text box header / article name */}
        {(isText(articleText)) &&
          <a href={linkUrl} target="_blank" rel="noopener nofollow" data-link-type="text-link" >
            <MiniHed className="sub-head" data={articleText}/>
          </a>
        }
        {/* horizontal rule divider and body text */}
        {!isEmpty &&
          <Fragment>
            <hr className="rule"></hr>
            <BodyText className="body-text" data={bodyText}/>
          </Fragment>
        }
        {/* BUTTON WILL GO HERE */}
        <div className='related-story-btn-wrapper'>{renderedButton}</div>
      </div>
    </div>
  );
};

RelatedArticle.propTypes = {
  article: PropTypes.object,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  isPage: PropTypes.bool,
  slug: PropTypes.string,
};

export default RelatedArticle;
